import { useState, useEffect } from 'react';
import { useLocalStorage } from './useLocalStorage';

interface Achievement {
  id: string;
  title: string;
  description: string;
  icon: string;
  unlockedAt?: string;
}

export function useAchievements() {
  const [achievements, setAchievements] = useLocalStorage<Achievement[]>('achievements', []);
  const [latestAchievement, setLatestAchievement] = useState<Achievement | null>(null);

  const checkAndUnlockAchievement = (id: string) => {
    const achievement = achievements.find(a => a.id === id && !a.unlockedAt);
    if (achievement) {
      const updatedAchievement = { 
        ...achievement, 
        unlockedAt: new Date().toISOString() 
      };
      setAchievements(achievements.map(a => 
        a.id === id ? updatedAchievement : a
      ));
      setLatestAchievement(updatedAchievement);
    }
  };

  return {
    achievements,
    latestAchievement,
    checkAndUnlockAchievement
  };
} 